import { type UploadItem } from '@/hooks/useUploader';
import { cn } from '@/lib/cn';

export const UploadProgress = ({ upload }: { upload: UploadItem }) => {
  if (upload.status !== 'uploading') {
    return null;
  }

  return (
    <div
      style={{ width: `${upload.progress}%` }}
      className={cn('progress rounded-default absolute inset-0 top-0 left-0 z-0 h-full transition-all duration-300', {
        'animate-[slide_2s_linear_infinite] bg-[linear-gradient(90deg,var(--color-blue-50)_0%,var(--color-blue-200)_40%,var(--color-blue-50)_80%)] bg-size-[200%_100%] dark:bg-[linear-gradient(90deg,var(--color-stone-800)_0%,var(--color-stone-700)_40%,var(--color-stone-800)_80%)]':
          upload.status === 'uploading'
      })}
    ></div>
  );
};
